import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Toaster } from "./components/ui/sonner";
import LoginPage from "./pages/LoginPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import DashboardPage from "./pages/DashboardPage";
import RoadmapPage from "./pages/RoadmapPage";
import ModulesPage from "./pages/ModulesPage";
import ModuleDetailPage from "./pages/ModuleDetailPage";
import RestaurantsPage from "./pages/RestaurantsPage";
import RestaurantDetailPage from "./pages/RestaurantDetailPage";
import IdeasPage from "./pages/IdeasPage";
import IdeaSubmitPage from "./pages/IdeaSubmitPage";
import TasksPage from "./pages/TasksPage";
import ReleaseFeaturesPage from "./pages/ReleaseFeaturesPage";
import SettingsPage from "./pages/SettingsPage";
import RestaurantSubmitPage from "./pages/RestaurantSubmitPage";
import { homeFor } from "./lib/roles";

function RootRedirect() {
  const { isAuthenticated, loading, user } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F5F5F5]">
        <div className="w-8 h-8 border-4 border-[#CFFF40] border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }
  
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return <Navigate to={homeFor(user?.role)} replace />;
}

const ROLES_ADMIN = ["admin"];
const ROLES_ADMIN_RESTAURANT = ["admin", "restaurant"];
const ROLES_ADMIN_PARTNER = ["admin", "partner"];
const ROLES_ADMIN_PARTNER_RESTAURANT = ["admin", "partner", "restaurant"];
const ROLES_ADMIN_DEVELOPER = ["admin", "developer"];
const ROLES_RELEASE = ["admin", "partner", "developer"];
const ROLES_RESTAURANT = ["restaurant"];

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<RootRedirect />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      
      <Route path="/dashboard" element={<ProtectedRoute allowedRoles={ROLES_ADMIN_RESTAURANT}><DashboardPage /></ProtectedRoute>} />
      <Route path="/roadmap" element={<ProtectedRoute allowedRoles={ROLES_ADMIN_PARTNER}><RoadmapPage /></ProtectedRoute>} />
      <Route path="/modules" element={<ProtectedRoute allowedRoles={ROLES_ADMIN_PARTNER}><ModulesPage /></ProtectedRoute>} />
      <Route path="/modules/:id" element={<ProtectedRoute allowedRoles={ROLES_ADMIN_PARTNER}><ModuleDetailPage /></ProtectedRoute>} />
      <Route path="/restaurants" element={<ProtectedRoute allowedRoles={ROLES_ADMIN_PARTNER}><RestaurantsPage /></ProtectedRoute>} />
      <Route path="/restaurants/:id" element={<ProtectedRoute allowedRoles={ROLES_ADMIN_PARTNER}><RestaurantDetailPage /></ProtectedRoute>} />
      <Route path="/ideas" element={<ProtectedRoute allowedRoles={ROLES_ADMIN_PARTNER_RESTAURANT}><IdeasPage /></ProtectedRoute>} />
      <Route path="/submit-idea" element={<ProtectedRoute allowedRoles={ROLES_ADMIN_PARTNER_RESTAURANT}><IdeaSubmitPage /></ProtectedRoute>} />
      <Route path="/tasks" element={<ProtectedRoute allowedRoles={ROLES_ADMIN_DEVELOPER}><TasksPage /></ProtectedRoute>} />
      <Route path="/release-features" element={<ProtectedRoute allowedRoles={ROLES_RELEASE}><ReleaseFeaturesPage /></ProtectedRoute>} />
      <Route path="/submit-request" element={<ProtectedRoute allowedRoles={ROLES_RESTAURANT}><RestaurantSubmitPage /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute allowedRoles={ROLES_ADMIN}><SettingsPage /></ProtectedRoute>} />
      
      <Route path="*" element={<RootRedirect />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
